
export enum MenuActionTypes {
    ACTION_SET_CONTRATO = 'ACTION_SET_CONTRATO',
    ACTION_SET_CODIGOESCOLA = 'ACTION_SET_CODIGOESCOLA',
    ACTION_SET_CODIGOGRUPOUSUARIO = 'ACTION_SET_CODIGOGRUPOUSUARIO',
    ACTION_SET_CODIGOPROFESSOR = 'ACTION_SET_CODIGOPROFESSOR',
    ACTION_SET_CODIGORESPONSAVEL = 'ACTION_SET_CODIGORESPONSAVEL',
    ACTION_SET_CODIGOALUNO = 'ACTION_SET_CODIGOALUNO',
    ACTION_SET_CODIGOUSUARIO = 'ACTION_SET_CODIGOUSUARIO',
    ACTION_SET_ANO = 'ACTION_SET_ANO',
    ACTION_SET_SEMESTRE = 'ACTION_SET_SEMESTRE',
    ACTION_SET_READONLY = 'ACTION_SET_READONLY',
    ACTION_SET_CHAMADA_VIA_PROXY = 'ACTION_SET_CHAMADA_VIA_PROXY',
    MenuActionTypes = "MenuActionTypes"
}

